// @ts-nocheck - TODO: Add jQuery type declarations and fix union type complexity
/* eslint-disable no-unused-vars, no-undef */
import type { MouseEvent } from 'react';
import styled from '@emotion/styled';
import { Button } from 'react-bootstrap';
import { BsCashStack, BsExclamationTriangleFill } from 'react-icons/bs';
import { NumericFormat } from 'react-number-format';
import type { TranslationFunction } from '../../types/common';

interface BalanceDueBannerProps {
	outstandingBalAlert?: string;
	outstandingBalAmt?: number | string;
	outstandingBalPayNowLink?: boolean;
	actingAsPublicId?: string;
	platform?: string;
	t?: TranslationFunction;
}

const BalanceDueBanner = ({
	outstandingBalAlert,
	outstandingBalAmt,
	outstandingBalPayNowLink,
	actingAsPublicId,
	platform,
	t = (key: string) => key,
}: BalanceDueBannerProps) => {
	const BannerDiv = styled.div(`
		background-color: ${outstandingBalAlert && outstandingBalAlert === 'pastdue' ? 'var(--bs-red-100)' : 'var(--bs-yellow-200)'};
		color: ${outstandingBalAlert && outstandingBalAlert === 'pastdue' ? 'var(--bs-red-500)' : 'var(--bs-yellow-900)'};
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 99;
		padding: 0.5rem;
		margin-left: 0;
		height: 40px;
		width: auto;

		@media only screen and (max-width: 767px) {
			width: 100%;
		}

		@media only screen and (min-width: 992px) {
			margin-left: 12vw;
		}
	`);

	const handleButtonClick = (e: MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();

		if (platform === 'social' && actingAsPublicId && (outstandingBalPayNowLink && outstandingBalPayNowLink === true)) {
			window.location.href = '/settings/billing#update';
			return;
		}

		if (actingAsPublicId && (outstandingBalPayNowLink && outstandingBalPayNowLink === true)) {
			jQuery.iqAgents_PayCompanyBalance(actingAsPublicId);
		} else if (actingAsPublicId) {
			jQuery.iqAgentFees_PrintStatementDialog(
				'0',
				actingAsPublicId,
				'0',
				'0',
				'statement_list',
				'F',
			);
		}
	};

	return (
		<BannerDiv className={`balance-banner ${platform === 'client' ? 'rounded-1' : ''}`}>
			{(platform === 'client') && ((outstandingBalAlert && outstandingBalAlert === 'pastdue') ? <BsExclamationTriangleFill className="mx-2" size={18}/> : <BsCashStack className="mx-2" size={18}/>)}
			<div className="balance-banner-text mx-1">
				{platform === 'social' ?
					`${t('outstandingFees')} ${(outstandingBalAlert && outstandingBalAlert === 'pastdue') ? t('outstandingPastDue') : t('due')}`
					: `${(outstandingBalAlert && outstandingBalAlert === 'pastdue') ? t('feesPastDue') : t('upcomingFeesDue')}`
				}
				{platform === 'client' && outstandingBalAmt &&
					<NumericFormat
						decimalScale={2}
						displayType="text"
						prefix="$"
						thousandSeparator={true}
						value={outstandingBalAmt}
					/>}
			</div>
			<Button
				className={`balance-banner-button balance-banner-text px-1 ms-1 my-2 text-decoration-underline fw-bold ${outstandingBalAlert && outstandingBalAlert === 'pastdue' ? 'text-red-500' : 'text-yellow-900'}`}
				variant="link"
				onClick={(e) => handleButtonClick(e)}
			>
				{platform === 'client' ?
					`${(outstandingBalPayNowLink && outstandingBalPayNowLink === true) ? t('payNow') : t('seeStatement')}`
					: `${(outstandingBalPayNowLink && outstandingBalPayNowLink === true) ? t('updateBilling') : t('seeStatement')}`
				}
			</Button>
		</BannerDiv>
	);
};

export default BalanceDueBanner;
